module.exports = __webpack_public_path__ + "static/Badge-cbd575888656aab9d5f17ac7088ce78b.png";